<template>
  <div class="beauty">
    <van-nav-bar :title="$t('choose.nav')" />

    <div class="type">
      <div class="top">
        <img src="/img/ko.jpg" alt="" style="width: 100%" />
      </div>

      <div v-if="canAccess" class="nav_tab">
        <a :class="{ active: address_id === 'all' }" @click="changeAddress('all')">
          {{ $t('common.all') }}
        </a>
        <a
          v-for="item in addlist"
          :key="item.id"
          :class="{ active: item.id == address_id }"
          @click="changeAddress(item.id)"
        >
          {{ item.name }}
        </a>
      </div>

      <template v-if="canAccess">
        <div v-if="typeshow == 1" class="type1" @scroll="handleScroll">
          <div class="van-list">
            <div>
              <ul class="list">
                <li v-for="(item, index) in osList" :key="'os-' + index">
                  <div class="dd">
                    <span><i>{{ $t('home.gaoji') }}</i></span>
                    <img :src="item.image" :alt="item.id" @click="profile(item.id)" />
                    <div class="fot">
                      <a @click.stop="profile(item.id)">{{ $t('home.apply') }}</a>
                    </div>
                  </div>
                  <div class="di">
                    <a>
                      <van-icon name="like" color="rgb(220, 99, 161)" size="14" />
                      {{ item.renqi }}
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="list">
                <li v-for="(item, index) in jsList" :key="'js-' + index" @click="profile(item.id)">
                  <div class="dd">
                    <span><i>{{ $t('home.gaoji') }}</i></span>
                    <img :src="item.image" :alt="item.id" @click.stop="profile(item.id)" />
                    <div class="fot">
                      <a @click.stop="profile(item.id)">{{ $t('home.apply') }}</a>
                    </div>
                  </div>
                  <div class="di">
                    <a>
                      <van-icon name="like" color="rgb(220, 99, 161)" size="14" />
                      {{ item.renqi }}
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div v-else class="type2" @scroll="handleScroll">
          <div class="van-list">
            <ul class="list">
              <li
                v-for="(item, index) in tableList"
                :key="index"
                class="btn"
                @click="profile(item.id)"
              >
                <div class="left">
                  <img :src="item.image" alt="" />
                  <span><i>{{ $t('home.gaoji') }}</i></span>
                </div>
                <div class="right">
                  <div class="title">
                    <span>
                      <img class="badge-icon" src="/img/vipu.png" alt="" />
                      {{ $t('home.smrz') }}
                    </span>
                    <span>
                      <img class="badge-icon" src="/img/vipu.png" alt="" />
                      {{ $t('home.videorz') }}
                    </span>
                  </div>
                  <div class="tips">
                    <span
                      v-for="(tag, ti) in (item.tags_arr || []).slice(0, 3)"
                      :key="ti"
                    >{{ tag }}</span>
                  </div>
                  <div class="sm">
                    <p class="sf">
                      {{ $t('home.star') }}：
                      <span v-for="n in getStarCount(item.star)" :key="n"></span>
                    </p>
                    <div>
                      {{ $t('home.sg') }}: {{ item.sg }}cm
                      {{ $t('home.xw') }}：{{ item.xw }}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </template>

      <template v-else>
        <div
          style="display: flex; flex-wrap: wrap; padding: 10px; overflow: auto; height: calc(100vh - 20rem)"
        >
          <div
            v-for="n in 6"
            :key="n"
            style="margin-bottom: 10px; width: 45%; margin: 0 auto 10px"
          >
            <div style="height: 200px; background-color: #f6f7f8; margin-bottom: 10px"></div>
            <van-skeleton :row="2" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getStoredLang } from '../../utils/lang'
import { parseServiceTags } from '../../utils/xuanfeiTags'

export default {
  data() {
    return {
      addlist: [],
      address_id: 'all',
      typeshow: 1,
      page: 1,
      limit: 20,
      loading: false,
      finished: false,
      tableList: [],
    }
  },
  computed: {
    ...mapState(['userInfo']),
    canAccess() {
      if (!localStorage.getItem('token')) return true
      return this.userInfo.is_bet !== 0
    },
    osList() {
      return this.tableList.filter((_, index) => index % 2 === 0)
    },
    jsList() {
      return this.tableList.filter((_, index) => index % 2 === 1)
    },
  },
  methods: {
    getStarCount(star) {
      const count = parseInt(star, 10)
      return Number.isNaN(count) ? 5 : Math.min(Math.max(count, 0), 5)
    },
    normalizeItem(item) {
      const lang = getStoredLang()
      const tags_arr = parseServiceTags(item, lang)
      return {
        ...item,
        image: item.image || item.img_url,
        class_name: item.class_name || '',
        tags_arr,
        renqi: item.renqi || item.dianzan || item.chakan || item.sort || 0,
        sg: item.sg || item.hight || '',
        xw: item.xw || item.bust || '',
        star: item.star || 5,
      }
    },
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 5 && !this.loading && !this.finished) {
        this.getList()
      }
    },
    profile(id) {
      this.$router.push({ path: '/Profile', query: { id } })
    },
    changeAddress(id) {
      this.address_id = id
      this.page = 1
      this.tableList = []
      this.finished = false
      this.getList()
    },
    getList() {
      if (this.loading || this.finished) return
      this.loading = true
      const listId = this.address_id === 'all' ? 'all' : this.address_id
      this.$http({
        method: 'get',
        url: 'xuanfeilist',
        data: { id: listId, page: this.page, limit: this.limit },
      })
        .then((res) => {
          let list = []
          if (res.data && Array.isArray(res.data.data)) {
            list = res.data.data
          } else if (Array.isArray(res.data)) {
            list = res.data
          }
          list = list.filter((item) => item && (item.image || item.img_url)).map((item) => this.normalizeItem(item))
          if (list.length === 0) {
            this.finished = true
          } else {
            this.tableList = this.tableList.concat(list)
            this.page++
            if (list.length < this.limit) {
              this.finished = true
            }
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    },
    getAddress() {
      this.$http({ method: 'get', url: 'address_list' }).then((res) => {
        if (Array.isArray(res.data)) {
          this.addlist = res.data.flat ? res.data.flat() : res.data.reduce((acc, cur) => acc.concat(cur), [])
        }
      })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res.code === 200) {
          this.$store.commit('setUserInfoValue', res.data)
          if (res.data.status !== 1) {
            this.$toast(this.$t('video.account_out'))
            localStorage.clear()
            this.$router.push({ path: '/Login' })
            return
          }
          if (res.data.is_bet !== 0) {
            this.getAddress()
            this.getList()
          }
        }
      })
    },
  },
  mounted() {
    this.typeshow = localStorage.getItem('typeshow') || 1
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo()
    } else {
      this.getAddress()
      this.getList()
    }
  },
}
</script>

<style lang="less" scoped>
.beauty {
  width: 100%;
  background: #fff;
  padding-bottom: 4rem;
  min-height: 100vh;

  /deep/ .van-nav-bar {
    z-index: 999;
    position: relative;
    height: 3rem;
    line-height: 3rem;
    width: 100%;
    background-color: #df5b8d;
    background-image: url(/img/header.svg);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;

    .van-nav-bar__content {
      height: 3rem;
      align-items: center;
    }

    .van-nav-bar__title {
      color: #fff;
      font-size: 1rem;
    }

    .van-nav-bar__left,
    .van-icon {
      color: #fff;
    }

    &::after {
      border-bottom-width: 0;
    }
  }
}

.type {
  position: relative;
  overflow-y: auto;
}

.nav_tab {
  display: flex;
  flex-wrap: wrap;
  padding: 0.66667rem;
  gap: 0.33333rem;

  a {
    padding: 0.26667rem 0.66667rem;
    font-size: 0.8rem;
    color: #999;
    border-radius: 0.33333rem;
    border: 1px solid transparent;

    &.active {
      color: #333;
      background: #e2e2e2;
      border-color: #b979b1;
    }
  }
}

.type1,
.type2 {
  height: calc(100vh - 10rem);
  overflow-y: auto;
}

.type1 .van-list > div {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 96%;
  margin: 0 auto;
}

.type1 .list {
  width: calc(50% - 0.66667rem);
  margin: 0 auto;
  border-top: 1px solid #eee;
  margin-top: 0.66667rem;
  padding-top: 0.66667rem;
}

.list li {
  width: 100%;
  padding-bottom: 0.66667rem;
  list-style: none;

  > p {
    text-align: left;
    color: #666;
    font-size: 0.76667rem;
    padding-top: 0.2rem;
  }
}

.list li .di {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  font-size: 0.76667rem;
  padding: 0.2rem 0;

  p {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    i {
      display: inline-block;
      margin-right: 0.2rem;
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      background: #efba8f;
    }
  }
}

.list li .dd {
  border-radius: 0.33333rem;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    display: block;
  }

  span {
    position: absolute;
    z-index: 1;
    top: -5.33333rem;
    right: -8.66667rem;
    width: 10rem;
    height: 10rem;
    background: #ebcaaf;
    transform: rotate(45deg);
    opacity: 0.8;

    i {
      position: absolute;
      bottom: 0;
      left: 1.83333rem;
      color: #8d684b;
      font-weight: 600;
      font-style: normal;
    }
  }

  .fot {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    padding: 0.33333rem 5%;
    font-size: 0.76667rem;

    a {
      color: #fff;
    }
  }
}

.type2 .list li.btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  margin-bottom: 0.66667rem;
  background: #f3f2f7;
  padding: 0.33333rem;

  .left {
    width: 6.93333rem;
    overflow: hidden;
    border-radius: 0.33333rem;
    position: relative;

    img {
      width: 100%;
      display: block;
    }

    span {
      position: absolute;
      transform: rotate(45deg);
      right: -5.66667rem;
      width: 6.66667rem;
      height: 6.66667rem;
      top: -3.33333rem;
      background: #ebcaaf;
      color: #8d684b;
      opacity: 0.9;

      i {
        position: absolute;
        font-weight: 600;
        left: 0.8rem;
        bottom: 0;
        font-size: 0.8rem;
        font-style: normal;
      }
    }
  }

  .right {
    flex: 1;
    padding-left: 0.66667rem;

    .title {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      span {
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, #e7caaf, #fff7ed);
        color: #a4826b;
        font-weight: 600;
        margin-right: 0.2rem;
        padding: 0.16rem 0.4rem;
        font-size: 0.73333rem;
        border-radius: 0.46667rem 0 0.46667rem 0;
      }

      p {
        width: 100%;
        margin: 0.2rem 0 0;
        font-size: 0.86667rem;
      }
    }

    .badge-icon {
      width: 1rem;
      height: 1rem;
      margin-right: 0.1rem;
    }

    .tips {
      display: flex;
      flex-wrap: wrap;
      padding: 0.33333rem 0;

      span {
        padding: 0.2rem 0.4rem;
        margin: 0.16667rem;
        color: #fff;
        border-radius: 0.33333rem;
        font-size: 0.76667rem;
        background: #ff7186;
      }
      span:nth-child(2) {
        background: #ff9f43;
      }
      span:nth-child(3) {
        background: #54a0ff;
      }
    }

    .sm {
      text-align: left;
      color: #666;
      font-size: 0.8rem;

      .sf {
        display: flex;
        align-items: center;
        padding-bottom: 0.33333rem;

        span {
          width: 4.267vw;
          height: 4.267vw;
          background: url(/img/star.png) no-repeat 50% / 100%;
        }
      }
    }
  }
}
</style>
